import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { usePersona, ExperienceMode } from './usePersona';
import { ThemedText } from '@/components/ThemedText';
import { impactAsync, ImpactFeedbackStyle } from '@/lib/haptics';

const MODES: { key: ExperienceMode; label: string }[] = [
  { key: 'plain', label: 'Plain' },
  { key: 'professional', label: 'Pro' },
];

/** Both choices stay visible so changing depth never becomes a guess. */
export function PlainLanguageToggle(): React.ReactElement {
  const { mode, setMode } = usePersona();

  return (
    <View
      style={styles.menu}
      accessibilityLabel="Choose how Fahali explains the market"
      testID="persona-mode-menu"
    >
      {MODES.map(({ key, label }) => {
        const selected = mode === key;
        return (
          <Pressable
            key={key}
            onPress={() => {
              if (selected) return;
              impactAsync(ImpactFeedbackStyle.Light);
              setMode(key);
            }}
            accessibilityRole="button"
            accessibilityLabel={`${label} market language`}
            accessibilityState={{ selected }}
            testID={`persona-mode-${key}`}
            style={({ pressed }) => [
              styles.option,
              selected && styles.optionSelected,
              pressed && !selected ? styles.optionPressed : null,
            ]}
          >
            <ThemedText type="caption" style={[styles.label, selected && styles.labelSelected]}>
              {label}
            </ThemedText>
          </Pressable>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  menu: {
    flexDirection: 'row',
    alignItems: 'center',
    width: 116,
    height: 36,
    padding: 2,
    borderRadius: 9,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.18)',
    backgroundColor: 'rgba(36,34,31,0.97)',
    shadowColor: '#000000',
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.24,
    shadowRadius: 8,
    elevation: 8,
  },
  option: {
    flex: 1,
    height: 30,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 6,
  },
  optionSelected: { backgroundColor: '#D9AE5F' },
  optionPressed: { backgroundColor: 'rgba(255,255,255,0.12)' },
  label: {
    color: '#B9B4AA',
    fontSize: 12,
    lineHeight: 16,
    fontWeight: '600',
  },
  labelSelected: {
    color: '#24221F',
    fontWeight: '800',
  },
});
